import React, { useEffect, useRef, useState } from 'react'
import styles from './SuperSearch.module.css'
// import { callApi } from '../../../utils/call-api'
// import NotificationHandler from '../NotificationHandler'
// import { enumUtil } from '../enum'
import { enumUtil } from '../../../utils/Enum'
import NotificationHandler from '../../../utils/NotificationHandler'
import { ServerRequestProtected } from '../../../utils/ServerDataRequest'
import useDebounce from '../../../customhooks/useDebounce'
import isNull from '../../../utils/NullChecking'

// =============================== CUSTOM HELPER FUNCTIONS ==========================
const getupdateArray = (cols, rows) => {
  const updatedarr = rows.map((row) => {
    let obj = {}
    cols.forEach((ele) => {
      // const ddd = ele.replace(/\s/g, '').toLowerCase()
      obj[ele.bindingValue] = row[ele.bindingValue]
    })
    console.log(obj);

    return obj
  })
  return updatedarr
}

/** ================                             ===============
 * =================  PROPS AND THERE USES ===============
 *  ================                             ===============
 * ApiLink: complete api link from whre you want to search your result ... *required
 * method: name of method you are using to hit API. Only two methods are allowed (post and get)...*required
 * postBody:if you are  using post method in method prop then you need to pass an object ....* only required if method="post"
 * tableHeight: if you want to set custom height of table (type:number, eg 45,69) ...*required
 * tableWidth : if you want to set custom width of table(type:string, eg:"34px","76px")
 * getSelectedData: pass function which  give complete data of single row you clicked on its first parameter...*required
 * onChange: pass function which which will chnge the input field...*required
 * searchValue: value used in inputfield...*required
 * id: any unique string...*required
 * disabled:if you want to  disable the inputfield then pass true
 * tableData:it will be an array of object with 3 keys
 *            columName:string to show as a column name...*required
 *            bindingValue: to show the value in each column.... must match with the api response...*required
 *            columnWidth: string to set custom width og each column in % eg: 12%,34%
 * customData: it will be an array of object with 4 key
 *              id:any unique string
 *              label:any string
 *              value:any string
 *              description:any string
 * Note: when there is data in customData then no api will run
 */

const SuperSearch = (props) => {
  const [tableData, settableData] = useState([])
  const [selectedRowNumber, setselectedRowNumber] = useState(0)
  const [showTable, setshowTable] = useState(false)
  const [searchStatus, setsearchStatus] = useState(false)
  const [s_Value, sets_Value] = useState('')
  const tableBodyRef = useRef(null);
  const inputRef = useRef(null);
  const addNewButtonRef = useRef(null);
    const dropdownRef = useRef(null);
  

  const [NoDataFound, setNoDataFound] = useState(false)
  const debouncedSearchTerm = useDebounce(props.searchValue, 500);

  // ====================== RESETING THE COMPONENT TO ITS ORIGINAL STATE================
  const resetComponent = () => {
    props.getSelectedData(null)
    settableData([])
    setselectedRowNumber(0)
    setshowTable(false)
    setsearchStatus(false)
    sets_Value('')
  }

  // ====================== ON CLICKING SINGLE ROW OF TABLE ================
  const handleSingleRow = (singlerow, index) => {
    
    setselectedRowNumber(index)
    props.getSelectedData(singlerow, props.name, props.type)
    setshowTable(false)
    setsearchStatus(false)
    sets_Value('')
    setselectedRowNumber(0)
    setNoDataFound(false)
  }

   useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          tableBodyRef.current && tableBodyRef.current.contains(event.target) // Click inside dropdown
        ) {
          return; // Do nothing, keep the dropdown open
        }
        if (
          dropdownRef.current && dropdownRef.current.contains(event.target) // Click inside tabs
        ) {
          return; // Do nothing, keep the dropdown open
        }
        if (
          addNewButtonRef.current && addNewButtonRef.current.contains(event.target) // Click inside tabs
        ) {
          return; // Do nothing, keep the dropdown open
        }
        // Click outside, close the dropdown
        setNoDataFound(false)
        setshowTable(false);
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

  // ========================= ON KEY DOWN PRESSED INPUT FIELD======================
  const onKeyDownPressed = async (e) => {
    if (e.keyCode === 13) {
      // User pressed the ENTER key
      if (tableData.length > 0) {
        await props.getSelectedData(tableData[selectedRowNumber], e.keyCode)
        setshowTable(false)
        //setselectedRowNumber(0)
        setsearchStatus(false)
        sets_Value('')
      }
    } else if (e.keyCode === 38) {
      // if user presses the UP
      if (selectedRowNumber > 0) {
        setselectedRowNumber((prevSelectedRow) => prevSelectedRow - 1)
        var elem = document.getElementById(selectedRowNumber - 1)
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        })
      }
    } else if (e.keyCode === 40) {
      // IF USER PRESSES DOWN KEY
      if (selectedRowNumber < tableData.length - 1) {
        setselectedRowNumber((prevSelectedRow) => prevSelectedRow + 1)
        var elem = document.getElementById(selectedRowNumber + 1)
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        })
      }
    } else if (e.keyCode === 27) {
      // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
      props.getSelectedData(null)
      settableData([])
      setshowTable(false)
      setselectedRowNumber(0)
    } else if (e.keyCode === 9) {
      // IF USER PRESSES THE TAB BUTTON
      if (tableData.length > 0) {
        props.getSelectedData(tableData[selectedRowNumber])
        setshowTable(false)
      }
    }
  }

  // =========================== ON CHANGE HANDLER OF THE INPUT FIELD =============================
  const onHandleChange = async (e) => {
    props.onChange(e)
    let eventValue = e.target.value
    sets_Value(eventValue)
    if (eventValue === '' && !props?.type === 'client') {
      setsearchStatus(false)
      setselectedRowNumber(0)
    } else if (eventValue === '' && props?.type === 'client' && props?.tableData?.length > 0 && props.customData?.length > 0) {
      setsearchStatus(true)
      setselectedRowNumber(0)
    } else {
      setsearchStatus(true)
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tableBodyRef.current && !tableBodyRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
        setshowTable(false)
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const searchByKeys = (data) => {
    const searchTerm = debouncedSearchTerm?.toLowerCase();
    if (props?.searchBy) {
      return props.searchBy.some((key) =>
        data[key]?.toLowerCase().includes(searchTerm)
      );
    }
    return data.display?.toLowerCase().includes(searchTerm);
  };

  useEffect(() => {
    if (props?.type === 'client' && props?.tableData?.length > 0 && props.customData?.length > 0) {
      let response = null
      response = props.customData.filter((cdata) => searchByKeys(cdata));
      settableData(response);
      if (response.length > 0 && searchStatus) {
        setshowTable(true)
      } else {
        setshowTable(false)
      }
    }

    const fetchData = async (ICD) => {
      try {
        const response = await fetch(`https://icd10api.com/?s=${ICD}&desc=short&r=json`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        let data = await response.json();
        data = data.Search
        return data;
        // if (data.Response === "True") {
        //   setshowTable(true)
        //   settableData(data.Search); 
        // }
      } catch (error) {
        // setError(error.message);
        return null;
      }
    };
    if (searchStatus) {
      if (!isNull(debouncedSearchTerm)) {
        if (debouncedSearchTerm.length >= 2) {
          ; (async () => {
            try {
              let response = null
              if (props.customData?.length > 0) {
                response = props.customData.filter((cdata) => searchByKeys(cdata));
                settableData(response)
                if (response.length > 0) {
                  setshowTable(true)
                } else {
                  setshowTable(false)
                }
              } else {
                if (props.method === 'post') {
                  if (!props.postBody) {
                    throw 'Post Body prop is not defined'
                  } // if postBody prop is not defined
                  else {
                    if (props.searchValue.length > 1) {
                      response = await ServerRequestProtected(
                        props.ApiLink,
                        props.method,
                        props.postBody,
                      )
                    }
                  }
                } else if (props.method === 'get') {
                  response = await fetchData(debouncedSearchTerm)
                  if (NoDataFound) {
                    setNoDataFound(false)
                  }
                  else {
                    setNoDataFound(true)
                  }


                } else {
                  throw 'Method not allowed'
                }
                if (response.hasOwnProperty('data')) {
                  settableData(response?.data)
                  if (response?.data?.length > 0) {
                    setshowTable(true)
                  } else {
                    setshowTable(false)
                  }
                } else {
                  settableData(response)
                  if (response.length > 0) {
                    setshowTable(true)
                  } else {
                    setshowTable(false)
                  }
                }
              }
            } catch (error) {
              console.log('ERROR', error)
              settableData([])
              setshowTable(false)
              NotificationHandler(error, enumUtil.enumtoaster.warning)
            }
          })()
        }
      }
    }
  }, [
    props.ApiLink,
    props.method,
    props.postBody,
    props.customData,
    debouncedSearchTerm
  ])

  return (
    <div
      id={`superSearchParentDiv_${props.id}`}
      className="position-relative"
      style={{ width: props.inputFieldWidth ? props.inputFieldWidth : '' }}

    >
      {/* <div className="input-group width105"> */}
      <div className={`input-group ${styles[props.sup_inp]}`}>

        <input
          ref={inputRef}
          onKeyDown={onKeyDownPressed}
          // disabled={props.disabled}
          onChange={onHandleChange}
          name={props.name}
          value={props.searchValue}
          id={`superSearchInputField_${props.id}`}
          type="text"
          autoComplete="off"
          // className="col yellowsearch"
          // className={`col ${styles.sup_yellowsearch}`}
          className={props.inputError ? `col ${styles.sup_yellowsearch_error}` : `col ${styles.sup_yellowsearch}`}
          placeholder="Search..."
          onFocus={() => { if (tableData.length > 0) { setshowTable(true) } }}
          readOnly={props.isReadOnly ? true : false}
        />
        {!props.disabled ? (
          <div className={`input-group-append ${styles.input_group_append}`}>
            {props.searchValue ? (
              <button onClick={resetComponent} className={`${styles.sup_btn_color} ${styles[props.sup_btn]}`}>
                <i className="bi bi-x" style={{ position: 'relative' }} />
              </button>
            ) : (
              <button className={`${styles.sup_btn_color} ${styles[props.sup_btn]}`}>
                {' '}
                <i className="bi bi-search" style={{ position: 'relative' }} />
              </button>
            )}
          </div>
        ) : null}
      </div>
      {(
        (showTable && searchStatus && s_Value === props.searchValue) ||
        (showTable && props?.type === 'client' && tableData?.length > 0 && props.customData?.length > 0)
      ) ? (
        <div
          className={`${styles.sup_tableWrapper} padding highZ ar_super-search-table`}
          style={{
            minHeight: `${tableData.length * 30 > props.tableHeight ? props.tableHeight : tableData.length * 30 + 45}px`,
            width: props.tableWidth ? props.tableWidth : '100%',
          }}
        >
          <table
            className="table table-hover table-responsive"
            style={{ height: 'inherit' }}
          >
            {props.ApiLink ? (
              <thead className={styles.sup_table_head}>
                <tr>
                  {props.tableData.map((data, i) => {
                    return (
                      <th
                        className={data.columnWidth ? '' : styles.sup_flexGrow}
                        style={{
                          width: data.columnWidth ? data.columnWidth : '',
                        }}
                        key={i}
                      >
                        {data.columName}
                      </th>
                    )
                  })}
                </tr>
              </thead>
            ) : null}
            {props.customData?.length > 0 ? (
              <thead className={styles.sup_table_head}>
                <tr >
                  {props.tableData.map((data, i) => {
                    return (
                      <th
                        className={data.columnWidth ? '' : styles.sup_flexGrow}
                        style={{
                          width: data.columnWidth ? data.columnWidth : '',
                        }}
                        key={i}
                      >
                        {data.columName}
                      </th>
                    )
                  })}
                </tr>
              </thead>
            ) : null}

            <tbody className={`table-body ${styles.sup_table_body}`} ref={tableBodyRef}>
              {props.customData?.length > 0
                ? tableData.map((tdata, index) => {
                  let row_selected = false
                  if (index === selectedRowNumber) {
                    row_selected = true
                  }
                  return (
                    <tr
                      id={index}
                      key={index}
                      className={row_selected ? 'row-is-selected' : ''}
                      onClick={() =>
                        handleSingleRow(tableData[index], index)
                      }
                    >
                      {props?.tableData?.length > 0 &&
                        props.tableData.map((it, index) => {
                          return <td style={{ width: index === 0 ? '' : '' }}>{tdata?.[it?.bindingValue]}</td>
                        })}
                    </tr>
                  )
                })
                : getupdateArray(props.tableData, tableData).map(
                  (trows, index) => {
                    let selected = false
                    if (index === selectedRowNumber) {
                      selected = true
                    }
                    return (
                      <tr
                        id={index}
                        key={index}
                        className={selected ? 'row-is-selected' : ''}
                        onClick={() =>
                          handleSingleRow(tableData[index], index)
                        }
                      >
                        {props.tableData.length > 0 && props.tableData.map((tcols, i) => {

                          if (i === 0) {
                            const sentence = trows[
                              tcols?.bindingValue
                            ].toString()
                            const word = props.searchValue
                            const case_insensitiveWord = new RegExp(
                              word.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'),
                              'i',
                            ) // for caseinsensitive
                            var start = sentence.search(case_insensitiveWord)
                            let findword = sentence.substr(start, word.length)
                            findword = `<b>${findword}</b>`
                            const new_Sentence = sentence.replace(
                              case_insensitiveWord,
                              findword,
                            )
                            return (
                              <td
                                className={
                                  tcols.columnWidth ? '' : styles.sup_flexGrow
                                }
                                style={{
                                  width: tcols.columnWidth ? tcols.columnWidth : 'auto',
                                  color: '#0392cf',
                                  fontSize: '12px',
                                  fontWeight: '700'

                                }}
                                key={i}
                                dangerouslySetInnerHTML={{
                                  __html: new_Sentence,
                                }}

                              />
                            )
                          } else {
                            return (
                              <td
                                className={
                                  tcols.columnWidth ? '' : styles.sup_flexGrow
                                }
                                style={{
                                  width: tcols.columnWidth
                                    ? tcols.columnWidth
                                    : 'auto',
                                  color: '#626569'
                                }}
                                key={i}
                              >
                                {trows[tcols.bindingValue]}
                              </td>
                            )
                          }
                        })}
                      </tr>
                    )
                  },
                )}
            </tbody>
          </table>
        </div>
      ) : props?.typefrom === 'Diagnosis' && NoDataFound ?

        <div className="" ref={addNewButtonRef}  >
          <div className="ar_superSearch-tabs-desc-list"  >
            <div className="ar_no-data-found">
              <div className="d-flex align-items-center justify-content-center no_text">
                <p className="text ar-light-color">Not found in the system!</p>
              </div>
              <div className="d-flex justify-content-between align-items-center px-2"  >
                <div className="d-flex align-items-center gap-1 cursor-pointer">
                  <i className="icon-dash-plus fw-900"></i>
                  <p className="text fs-11 validate-color text-decoration-underline lh-1" onClick={props.handleAddNewCode}>Add “ As New Dx</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        : null}
    </div>
  )
}
export default SuperSearch
